export const coreQueryKeys = {
	session: ["session"] as const,

	games: {
		all: ["games"] as const,
		list: (params: object) => ["games", "list", params] as const,
		detail: (id: string) => ["games", id] as const,
	},
	profiles: {
		all: ["profiles"] as const,
		list: (params: object) => ["profiles", "list", params] as const,
		detail: (id: string) => ["profiles", id] as const,
	},
	matches: {
		all: ["matches"] as const,
		list: (params: object) => ["matches", "list", params] as const,
		detail: (id: string) => ["matches", id] as const,
	},
	notifications: {
		all: ["notifications"] as const,
		list: (params: object) => ["notifications", "list", params] as const,
	},
} as const;
